module.exports = require('./build/react-swipeable-tabs');